// Pushes the operator's active workspace + project into the module-level
// scope that api() uses to rewrite per-project URLs into the nested
// `/api/workspaces/<wsId>/projects/<pId>/...` shape.
//
// Mounted high in the tree (App.tsx, above the routes) so the scope is
// set BEFORE any data fetch fires. Without this, per-project requests
// would fall back to the legacy URLs — and once Phase 2E deletes those,
// every page would return 404.
//
// Also drives the "no active project" state: when me.lastActiveProjectId
// is null, the children get rendered with an empty scope so the API
// client throws (or returns 412 from the legacy shim) and the UI
// switches into the project-picker landing page.

import { useEffect, type ReactNode } from "react";
import { useMe } from "@/hooks/useAuth";
import { setActiveApiScope } from "@/lib/api";

export default function WorkspaceProjectProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { data: me } = useMe();

  useEffect(() => {
    if (me?.lastActiveProjectId && me?.lastActiveWorkspaceId) {
      setActiveApiScope({
        workspaceId: me.lastActiveWorkspaceId,
        projectId: me.lastActiveProjectId,
      });
    } else {
      setActiveApiScope(null);
    }
  }, [me?.lastActiveProjectId, me?.lastActiveWorkspaceId]);

  return <>{children}</>;
}
